import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// const motList = [{ id: 1, value: '2', text: 'Role', text_nl: 'A' }]
const MerchandiseDetail = ({ saveData, updateData, renderForm, merchandiseId }) => {
  const dataSource = useSelector((state) => state.invoiceReducer.invoice.merchandiseMap[merchandiseId])
  const packageDataSource = useSelector(state => state.invoiceReducer.invoice.merchandiseMap[merchandiseId]?.packagesList) || []
  
  
  const dispatch = useDispatch()

  const onBlur = useCallback(
    //save Api
    (value, name) =>  saveData({ merchandiseId, data: { [name]: value } }),

    [saveData]
  )

  const onChange = useCallback(
    (value, name) =>  {dispatch(updateData({ merchandiseId, data: { [name]: value } }))},
    [merchandiseId, updateData]
  )

  const onSelect = useCallback(
    (...params) => {
      onChange(...params)
      onBlur(...params)
    },
    [onChange, onBlur]
  )
  return renderForm && renderForm({ onBlur, onSelect, onChange, dataSource, packageDataSource })
}

export default MerchandiseDetail
